import * as Yup from "yup";

export const csnValidationSchema = Yup.object({
  csn: Yup.string()
    .trim()
    .required("CSN or Order ID is required")
    .max(50, "CSN or Order ID must be 50 characters or less"),
});
